import React from 'react';
import ProprCalculator from './components/ProprCalculator';

function App() {
  return (
    <div className="App">
      <ProprCalculator />
    </div>
  );
}

export default App;